// src/Components/Forms/Financement/Salam/Proposition/Tab2.tsx
import React, { useState, useEffect } from 'react';
import { Box, Tooltip } from '@mui/material';
import { Spin, Space } from 'antd';
import Table from '../../../../TableResizable';
import type { ColumnsType } from 'antd/es/table';
import DataTypeTable from '../../../../../Types/DataTypeTable';
import formatNumber from '../../../../../Functions/Traitement/FormatNumber';
import ShowFile from '../../../../ShowFile';
import Data from '../../../../../Data/Data.json';
import InputForm from '../../../../InputT';

interface Tab2Props {
  form?: any;
}

const Tab2 = (props: Tab2Props) => {
  const [garanties, setGaranties] = useState<DataTypeTable[]>([]);
  const [loading, setLoading] = useState(false);
  const [totalGarantie, setTotalGarantie] = useState<number>(0);

  // Chargement des garanties depuis le localStorage
  const loadGaranties = () => {
    setLoading(true);
    try {
      const stored = localStorage.getItem(Data.LocalVariable.garantie);
      if (stored) {
        const parsed = JSON.parse(stored);
        if (Array.isArray(parsed)) {
          setGaranties(parsed);
          const total = parsed.reduce((acc, item) => acc + Number(item.valCouvert || 0), 0);
          setTotalGarantie(total);
        } else {
          setGaranties([]);
          setTotalGarantie(0);
        }
      } else {
        setGaranties([]);
        setTotalGarantie(0);
      }
    } catch (error) {
      console.error('Erreur lors du chargement des garanties:', error);
      setGaranties([]);
      setTotalGarantie(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadGaranties();
  }, []);

  // ✅ Colonnes originales (inchangées)
  const columns: ColumnsType<DataTypeTable> = [
    {
      title: 'Code Garantie',
      dataIndex: 'codgar',
    },
    {
      title: 'N° Identification',
      dataIndex: 'NUMIDENTI',
    },
    {
      title: 'Type Garantie',
      dataIndex: 'typgar',
    },
    {
      title: 'Localisation',
      dataIndex: 'LOCAL',
    },
    {
      title: 'Valeur Garantie',
      dataIndex: 'VALGARANTI',
    },
    {
      title: 'Valeur Couvert',
      dataIndex: 'valCouvert',
      render: (x) => (x ? formatNumber(Number(x)) + ' XAF' : ''),
    },
    {
      title: 'Désignation',
      dataIndex: 'DESIGNATION',
    },
    {
      title: 'Date Début',
      dataIndex: 'DATDEB',
    },
    {
      title: 'Date Fin',
      dataIndex: 'DATFIN',
    },
    {
      title: 'Commentaire',
      dataIndex: 'TEXTCOMMEN',
    },
    {
      title: 'Fichier',
      key: 'view',
      render: (_, record) =>
        record.fichier ? (
          <Space size="middle">
            <Tooltip title="Ouvrir le fichier">
              <ShowFile file={record.fichier} fileName={record.codgar + '-' + record.NUMCLI + '-' + record.DESIGNATION} />
            </Tooltip>
          </Space>
        ) : (
          'No file'
        ),
    },
  ];

  return (
    <Spin spinning={loading} size="large" style={{ color: 'green' }}>
      <div className="tabItem">
        <div>
          <Box fontStyle="inherit">
            <Box fontStyle="inherit" className="border-left border" width={"85%"} position={"absolute"}>
              <legend>Garanties Prêt</legend>
              <div>
                <Table
                  size="small"
                  columns={columns}
                  pagination={{ pageSize: 5, position: ['bottomRight'] }}
                  dataSource={garanties}
                />
              </div>
              <InputForm
                label="Valeur Total de garantie"
                value={totalGarantie}
                disabled={true}
                type="number"
                money
              />
            </Box>
          </Box>
        </div>
      </div>
    </Spin>
  );
};

export default Tab2;